import { User } from '@/types/user';

export const permissions = {
  enterpriseAdmin: (user: User): boolean => {
    return user.roles.includes('ENTERPRISE_ADMIN');
  },
  manageSettings: (user: User): boolean => {
    return user.roles.includes('MANAGE_SETTINGS');
  },
  manageSettingsOnly: (user: User): boolean => {
    return (
      user.roles.includes('MANAGE_SETTINGS') &&
      !user.roles.includes('ENTERPRISE_ADMIN')
    );
  },
  enterpriseMvp2Beta: (user: User): boolean => {
    return user.enable_mvp2_beta;
  },
};
